import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { useSelector } from 'react-redux';
import { selectNextBestActionEnabled } from 'core/userContext';

export const listNextBestActionEligibleCampaignIds = gql`
  query getListNextBestActionEligibleCampaignIds {
    listNextBestActionEligibleCampaignIds {
      campaignIds
    }
  }
`;

export const useListNextBestActionEligibleCampaigns = () => {
  const isNBAEnabled = useSelector(selectNextBestActionEnabled);
  return useGraphql(listNextBestActionEligibleCampaignIds, { skip: !isNBAEnabled });
};
